module.exports = __webpack_public_path__ + "0f6616c27d992e8af5a27a2fa8ef8c00.svg";